(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.documentElement;

    function activeSlide(slides) {
      return (
        slides.querySelector('slideshow-slide[aria-hidden="false"]') ||
        slides.querySelector('slideshow-slide')
      );
    }

    function fit(gallery, slide) {
      if (!root.classList.contains('pmg-adaptive-height')) return;
      const slides = gallery && gallery.querySelector('slideshow-slides');
      if (!slides) return;
      const target = slide || activeSlide(slides);
      if (!target) return;
      const height = target.getBoundingClientRect().height;
      if (height > 0) slides.style.height = `${Math.round(height)}px`;
    }

    function fitAll() {
      document.querySelectorAll('media-gallery.media-gallery--carousel').forEach((gallery) => fit(gallery));
    }

    document.addEventListener('slideshow:select', (event) => {
      const gallery = event.target.closest && event.target.closest('media-gallery');
      if (gallery) fit(gallery, event.detail && event.detail.slide);
    });

    document.addEventListener(
      'load',
      (event) => {
        if (event.target.tagName === 'IMG' && event.target.closest('media-gallery')) {
          fit(event.target.closest('media-gallery'));
        }
      },
      true
    );

    let resizeFrame;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(fitAll);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fitAll);
    } else {
      fitAll();
    }
    window.addEventListener('load', fitAll);
    document.addEventListener('shopify:section:load', fitAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["reading-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    function initReadingSelector(root) {
      if (root.dataset.readingReady) return;
      root.dataset.readingReady = 'true';

      const radios = Array.from(root.querySelectorAll('.reading-selector__radio'));
      const buyButton = root.querySelector('[data-reading-buy]');
      const dialog = root.querySelector('.reading-dialog');
      const form = root.querySelector('[data-reading-form]');
      const variantInput = root.querySelector('[data-reading-variant]');
      const selectedText = root.querySelector('[data-reading-selected]');
      const errorText = root.querySelector('[data-reading-error]');
      const submitButton = root.querySelector('[data-reading-submit]');
      const priorityToggle = root.querySelector('[data-reading-priority]');
      const priorityRow = priorityToggle?.closest('.reading-selector__priority');
      const priorityPrice = root.querySelector('[data-reading-priority-price]');
      const priorityProperty = root.querySelector('[data-reading-priority-property]');
      const originProperty = root.querySelector('[data-reading-origin]');
      const addAnotherButton = root.querySelector('[data-reading-add-another]');
      const addedPanel = root.querySelector('[data-reading-added]');
      const inCart = root.querySelector('[data-reading-in-cart]');
      const inCartList = root.querySelector('[data-reading-in-cart-list]');
      const shopRoot = window.Shopify?.routes?.root || '/';

      function formatMoney(cents) {
        return `$${(cents / 100).toFixed(2).replace(/\.00$/, '')}`;
      }

      // "Focused Reading – Relationship Guidance · $70 · Priority Delivery"
      function describeItem(item) {
        const [depth, priority] = item.options_with_values?.map((o) => o.value) || [];
        const shared = item.properties?.['_Started from'];
        let text = depth && depth !== item.product_title ? `${depth} – ${item.product_title}` : item.product_title;
        if (shared) text += ` (from ${shared})`;
        text += ` · ${formatMoney(item.final_line_price)}`;
        if (priority === 'Yes') text += ` · ${priorityToggle?.dataset.title || 'Priority Delivery'}`;
        return text;
      }

      async function fetchCart() {
        const response = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`Cart ${response.status}`);
        return response.json();
      }

      // Keeps the header bubble in step without a page reload.
      function updateCartBubble(count) {
        document.querySelectorAll('[ref="cartBubbleCount"]').forEach((el) => {
          el.textContent = count < 100 ? String(count) : '';
          el.classList.toggle('hidden', count === 0);
        });
        document.querySelectorAll('[ref="cartBubble"]').forEach((el) => el.classList.toggle('visually-hidden', count === 0));
      }

      const currentProductId = () => Number(currentRadio()?.dataset.productId || 0);

      async function removeLines(keys) {
        if (!keys.length) return;
        const updates = Object.fromEntries(keys.map((key) => [key, 0]));
        const response = await fetch(`${shopRoot}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }),
        });
        if (!response.ok) throw new Error(`Cart ${response.status}`);
      }

      // A reading that's redone (e.g. back from checkout with new answers) replaces the old one
      // rather than sitting beside it, so it can't be paid for twice. Other readings stay.
      // Best effort: if the cart can't be read, the reading is still added rather than blocking checkout.
      async function removeSameReading() {
        const productId = currentProductId();
        if (!productId) return;
        try {
          const cart = await fetchCart();
          await removeLines(cart.items.filter((item) => item.product_id === productId).map((item) => item.key));
        } catch (error) {
          console.warn('[reading-selector] Could not replace the earlier reading:', error);
        }
      }

      // Lists readings already in the cart, so they aren't bought twice by accident.
      async function showInCart() {
        if (!inCart || !inCartList) return;
        try {
          const cart = await fetchCart();
          const productId = currentProductId();
          inCartList.replaceChildren(
            ...cart.items.map((item) => {
              const li = document.createElement('li');
              let text = item.quantity > 1 ? `${describeItem(item)} × ${item.quantity}` : describeItem(item);
              if (item.product_id === productId) text += ' (will be replaced by this one)';
              li.append(`${text} `);
              const remove = document.createElement('button');
              remove.type = 'button';
              remove.className = 'reading-dialog__in-cart-remove';
              remove.textContent = 'Remove';
              remove.addEventListener('click', async () => {
                remove.disabled = true;
                try {
                  await removeLines([item.key]);
                  const updated = await fetchCart();
                  updateCartBubble(updated.item_count);
                } finally {
                  showInCart();
                }
              });
              li.append(remove);
              return li;
            })
          );
          inCart.hidden = cart.items.length === 0;
        } catch (error) {
          inCart.hidden = true;
        }
      }

      function showForm() {
        if (addedPanel) addedPanel.hidden = true;
        if (form) form.hidden = false;
      }

      function currentRadio() {
        return radios.find((r) => r.checked) || radios[0];
      }

      // The ticked box buys the reading's "Yes" variant instead of its "No" one.
      function activeVariantId() {
        const radio = currentRadio();
        if (!radio) return '';
        const twin = radio.dataset.priorityId;
        return priorityToggle?.checked && twin ? twin : radio.value;
      }

      function syncPriority() {
        if (!priorityToggle) return;
        const radio = currentRadio();
        const twin = radio?.dataset.priorityId;

        // A reading whose priority variant is missing or sold out can't offer the add-on.
        if (!twin) {
          priorityToggle.checked = false;
          priorityToggle.disabled = true;
          priorityRow?.classList.add('is-unavailable');
        } else {
          priorityToggle.disabled = false;
          priorityRow?.classList.remove('is-unavailable');
        }

        if (priorityPrice) {
          priorityPrice.textContent = twin ? ` — +${radio.dataset.priorityDiff}` : '';
        }
      }

      function syncSelectedText() {
        if (!selectedText) return;
        const radio = currentRadio();
        if (!radio) return;
        const price = priorityToggle?.checked && radio.dataset.priorityPrice
          ? radio.dataset.priorityPrice
          : radio.dataset.price;
        let text = `${radio.dataset.title} · ${price}`;
        if (priorityToggle?.checked) text += ` · ${priorityToggle.dataset.title}`;
        selectedText.textContent = text;
      }

      function syncVariant() {
        if (variantInput) variantInput.value = activeVariantId();

        if (originProperty) originProperty.disabled = !('sharedReading' in (currentRadio()?.dataset || {}));

        if (priorityProperty) {
          const radio = currentRadio();
          const on = Boolean(priorityToggle?.checked && radio?.dataset.priorityId);
          priorityProperty.disabled = !on;
          priorityProperty.value = on ? `+${radio.dataset.priorityDiff}` : '';
        }
      }

      priorityToggle?.addEventListener('change', () => {
        syncVariant();
        syncSelectedText();
      });

      const hasQuestions = () =>
        Boolean(form && form.querySelector('.reading-dialog__set:not([disabled]) .reading-dialog__field'));

      function select(radio) {
        radios.forEach((r) => r.closest('.reading-selector__option').classList.toggle('is-selected', r === radio));
        syncPriority();
        syncVariant();
        syncSelectedText();
        if (buyButton) buyButton.disabled = radio.disabled;

        // Question sets are keyed by the base variant id, which is the radio's own value.
        root.querySelectorAll('[data-form-for]').forEach((set) => {
          const active = set.dataset.formFor === radio.value;
          set.hidden = !active;
          set.disabled = !active;
        });
      }

      radios.forEach((radio) => radio.addEventListener('change', () => select(radio)));

      // Prime the add-on price and availability for whichever reading starts selected.
      syncPriority();
      syncVariant();
      syncSelectedText();

      async function goToCheckout() {
        if (submitButton) submitButton.setAttribute('aria-busy', 'true');
        if (errorText) errorText.hidden = true;
        try {
          // Keeps other readings in the cart, so several can be bought together.
          await removeSameReading();
          HTMLFormElement.prototype.submit.call(form);
        } catch (error) {
          if (submitButton) submitButton.removeAttribute('aria-busy');
          if (errorText) {
            errorText.textContent = 'Something went wrong. Please try again.';
            errorText.hidden = false;
          }
        }
      }

      async function addAndStay() {
        if (!form || !form.reportValidity()) return;
        addAnotherButton?.setAttribute('aria-busy', 'true');
        if (errorText) errorText.hidden = true;
        try {
          await removeSameReading();
          const response = await fetch(`${shopRoot}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
          const data = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');

          const cart = await fetchCart();
          const added = (data.items || [data])[0];
          const summary = root.querySelector('[data-reading-added-summary]');
          const count = root.querySelector('[data-reading-added-count]');
          if (summary && added) summary.textContent = describeItem(added);
          if (count) {
            const n = cart.item_count;
            count.textContent = `You have ${n} reading${n === 1 ? '' : 's'} in your cart (${formatMoney(cart.total_price)}).`;
          }
          updateCartBubble(cart.item_count);

          // The answers now belong to the reading in the cart; start the next one fresh.
          form.reset();
          if (priorityToggle) priorityToggle.checked = false;
          syncVariant();
          syncSelectedText();

          form.hidden = true;
          if (addedPanel) addedPanel.hidden = false;
          root.querySelector('[data-reading-added-heading]')?.focus();
        } catch (error) {
          if (errorText) {
            errorText.textContent = error.message || 'Something went wrong. Please try again.';
            errorText.hidden = false;
          }
        } finally {
          addAnotherButton?.removeAttribute('aria-busy');
        }
      }

      addAnotherButton?.addEventListener('click', addAndStay);

      buyButton?.addEventListener('click', () => {
        if (!form) return;
        if (!hasQuestions()) {
          goToCheckout();
          return;
        }
        showForm();
        showInCart();
        dialog.showModal();
      });

      root.querySelectorAll('[data-reading-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
      dialog?.addEventListener('close', showForm);

      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      form?.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        goToCheckout();
      });
    }

    function init(scope) {
      scope.querySelectorAll('[data-reading-selector]').forEach(initReadingSelector);
    }

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:block:select', (event) => init(event.target.closest('.shopify-section') || document));
  })();
  } catch(e) { console.error(e); }
})();

})();
